import type { CliE2eeRuntime } from '../../../../lib/e2ee/index.js';
import {
  decryptCliE2eeTranscriptPayload,
  e2eeKeyIdFromStoredString,
  storedStringHasE2eeEnvelope,
} from '../../../../lib/e2ee/decrypt-stored-e2ee-content.js';
import type { ParentTranscriptRowJson } from './types.js';

export function formatParentTranscriptText(
  rows: ParentTranscriptRowJson[],
  e2ee: CliE2eeRuntime | undefined,
): string {
  const lines = rows.map((row) => {
    const kind = typeof row.kind === 'string' ? row.kind : 'event';
    const rawPayload = typeof row.payload === 'string' ? row.payload : JSON.stringify(row.payload ?? '');
    if (storedStringHasE2eeEnvelope(rawPayload) && !e2ee) {
      throw new Error(`E2EE_REQUIRED:${e2eeKeyIdFromStoredString(rawPayload) ?? 'unknown'}`);
    }
    const payload = decryptCliE2eeTranscriptPayload(rawPayload, e2ee);
    return `[${kind}] ${payload}`;
  });
  return lines.join('\n');
}
